import React from 'react';

const IosInstallAnimation: React.FC = () => {
  return (
    <div className="relative w-[280px] h-[580px] mx-auto bg-black rounded-[2.5rem] shadow-[0_0_0_8px_#E2E8F0] overflow-hidden flex flex-col font-sans shrink-0 mt-2 mb-5">
      <style>
        {`
          /* Total Duration: 13s to feel relaxed */
          
          /* Modal slide up animation */
          @keyframes sheetSlideUp {
            0%, 6% { transform: translateY(100%); }
            12%, 46% { transform: translateY(0%); }
            49%, 100% { transform: translateY(100%); }
          }
          
          /* Modal internal content scroll */
          @keyframes sheetInnerScroll {
            0%, 20% { transform: translateY(0px); }
            30%, 46% { transform: translateY(-380px); }
            49%, 100% { transform: translateY(0px); }
          }
          
          /* The Touch Point Choreography */
          @keyframes touchPointCore {
            0%, 3% { transform: translate(140px, 500px) scale(1); opacity: 0; visibility: visible; }
            5% { transform: translate(140px, 550px) scale(1); opacity: 0; }
            /* 1: Approach Share Button */
            7% { transform: translate(140px, 536px) scale(1); opacity: 0.8; }
            /* 2: Tap Share Button */
            9% { transform: translate(140px, 536px) scale(0.6); opacity: 1; }
            11% { transform: translate(140px, 536px) scale(1); opacity: 0; }
            
            /* 3: Hide while Sheet slides up (11% to 20%) */
            12%, 23% { opacity: 0; transform: translate(240px, 450px) scale(1); visibility: hidden; }
            
            /* 4: Approach for Swipe Up (Swipe happens on the right empty space) */
            24% { transform: translate(240px, 450px) scale(1); opacity: 0.8; visibility: visible; }
            
            /* 5: Grab for swipe */
            26% { transform: translate(240px, 450px) scale(0.6); opacity: 1; }
            
            /* 6: Drag Up */
            31% { transform: translate(240px, 200px) scale(0.6); opacity: 1; }
            
            /* 7: INSTANT Vanish (prevents completely any trailing ghosting) */
            31.1%, 40% { transform: translate(240px, 200px) scale(0); opacity: 0; visibility: hidden; }
            
            /* 8: Snap to the Center of the Target Button */
            41% { transform: translate(140px, 285px) scale(1); opacity: 0; visibility: hidden; }
            
            /* 9: Fade in perfectly over the Center */
            42% { transform: translate(140px, 285px) scale(1); opacity: 0.8; visibility: visible; }
            
            /* 10: Final Tap on "Agregar a Inicio" */
            44% { transform: translate(140px, 285px) scale(0.6); opacity: 1; }
            46% { transform: translate(140px, 285px) scale(1); opacity: 0; }
            
            /* 11: Banish into space */
            47%, 100% { transform: translate(-9999px, -9999px) scale(0); opacity: 0; visibility: hidden; }
          }

          /* Ripple effect underneath the touch point during taps */
          @keyframes touchRipple {
            0%, 8% { transform: scale(0.5); opacity: 0; }
            /* Share tap */
            9% { transform: scale(3); opacity: 0.3; } 
            11%, 25% { transform: scale(0.5); opacity: 0; visibility: hidden; }
            
            /* Swipe grab */
            26% { transform: scale(2); opacity: 0.2; visibility: visible; } 
            31% { transform: scale(0.5); opacity: 0.1; }
            
            /* INSTANT vanish during scroll */
            31.1%, 43% { transform: scale(0); opacity: 0; visibility: hidden; }
            
            /* Final tap ripple */
            44% { transform: scale(3); opacity: 0.3; visibility: visible; } 
            
            /* Absolute vanish */
            46%, 100% { transform: scale(0); opacity: 0; visibility: hidden; }
          }

          /* Safari Share Icon Background Highlight */
          @keyframes shareBtnHighlight {
            0%, 8% { background-color: transparent; }
            9%, 12% { background-color: rgba(0,0,0,0.08); }
            13%, 100% { background-color: transparent; }
          }
          
          /* Agregar a Inicio Row Highlight */
          @keyframes addBtnHighlight {
            0%, 41% { background-color: rgba(91,101,220,0.05); transform: scale(1); }
            /* Pulse attention */
            42%, 43% { background-color: rgba(91,101,220,0.15); transform: scale(1.02); }
            /* Simulated press */
            44%, 47% { background-color: #D1D5DB; transform: scale(0.96); }
            /* Reset */
            48%, 100% { background-color: rgba(91,101,220,0.05); transform: scale(1); }
          }
          
          /* Safari Context Transition out to Home Screen */
          @keyframes safariContextExit {
             0%, 48% { opacity: 1; transform: scale(1); }
             51%, 88% { opacity: 0; transform: scale(0.7); }
             94%, 100% { opacity: 1; transform: scale(1); }
          }
          
          /* Home Screen Enters */
          @keyframes homeScreenEnter {
             0%, 48% { opacity: 0; transform: scale(1.1); pointer-events: none; }
             51%, 88% { opacity: 1; transform: scale(1); pointer-events: auto; }
             94%, 100% { opacity: 0; transform: scale(1.1); pointer-events: none; }
          }
          
          /* The App Icon dropping into place on Home Screen */
          @keyframes appIconDrop {
             0%, 55% { opacity: 0; transform: scale(3) translateY(-40px); }
             56% { opacity: 0.6; transform: scale(1.5) translateY(-10px); }
             60% { opacity: 1; transform: scale(0.9) translateY(2px); }
             63%, 100% { opacity: 1; transform: scale(1) translateY(0); }
          }

          .no-scrollbar::-webkit-scrollbar {
            display: none;
          }
        `}
      </style>

      {/* ====== 1. SAFARI CONTEXT (Closes at T=50%) ====== */}
      <div 
        className="absolute inset-0 bg-[#F2F2F7] flex flex-col will-change-transform z-10"
        style={{ animation: 'safariContextExit 13s infinite cubic-bezier(0.32, 0.72, 0, 1)', transformOrigin: 'center center' }}
      >
        <div className="flex-1 bg-white relative flex flex-col justify-center items-center">
          <div className="absolute top-1/3 flex flex-col items-center">
             <div className="w-20 h-20 bg-blue-50 text-[#5B65DC] rounded-[1.5rem] flex items-center justify-center mb-6">
                <svg className="w-10 h-10" fill="none" stroke="currentColor" viewBox="0 0 24 24" strokeWidth="2"><path d="M4 12v8a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-8"></path><polyline points="16 6 12 2 8 6"></polyline><line x1="12" y1="2" x2="12" y2="15"></line></svg>
             </div>
             <div className="h-5 w-48 bg-slate-100 rounded-full mb-4"></div>
             <div className="h-4 w-32 bg-slate-100 rounded-full"></div>
          </div>
        </div>

        {/* Safari Bottom Bar */}
        <div className="h-[75px] bg-[#F2F2F7]/90 backdrop-blur-md border-t border-black/5 flex justify-between items-start px-4 pt-3 pb-6 relative z-10">
          <svg className="w-[28px] h-[28px] text-blue-500/30" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><polyline points="15 18 9 12 15 6"></polyline></svg>
          <svg className="w-[28px] h-[28px] text-blue-500/30" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><polyline points="9 18 15 12 9 6"></polyline></svg>
          
          {/* Animated Share Icon */}
          <div 
            className="w-10 h-10 rounded-full flex items-center justify-center -mt-1.5 transition-colors" 
            style={{ animation: 'shareBtnHighlight 13s infinite cubic-bezier(0.4, 0, 0.2, 1)' }}
          >
            <svg className="w-[26px] h-[26px] text-blue-500" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
              <path d="M4 12v8a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-8"></path>
              <polyline points="16 6 12 2 8 6"></polyline>
              <line x1="12" y1="2" x2="12" y2="15"></line>
            </svg>
          </div>
          
          <svg className="w-[28px] h-[28px] text-blue-500/30" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M4 19.5A2.5 2.5 0 0 1 6.5 17H20"></path><path d="M6.5 2H20v20H6.5A2.5 2.5 0 0 1 4 19.5v-15A2.5 2.5 0 0 1 6.5 2z"></path></svg>
          <svg className="w-[28px] h-[28px] text-blue-500/30" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><rect x="3" y="3" width="18" height="18" rx="2" ry="2"></rect></svg>
        </div>

        {/* NATIVE IOS ACTION SHEET MODAL */}
        <div className="absolute inset-0 z-20 pointer-events-none flex flex-col justify-end">
          <div 
            className="bg-[#F2F2F7] h-[520px] rounded-t-[1.6rem] shadow-[0_-15px_40px_rgba(0,0,0,0.15)] flex flex-col overflow-hidden will-change-transform" 
            style={{ 
              animation: 'sheetSlideUp 13s infinite cubic-bezier(0.32, 0.72, 0, 1)', 
              transformOrigin: 'bottom',
              transform: 'translateY(100%)'
            }}
          >
            {/* Dragger Bar */}
            <div className="w-full h-5 flex items-center justify-center shrink-0 mt-2 mb-1">
              <div className="w-9 h-1.5 bg-black/15 rounded-full"></div>
            </div>
            
            {/* Header */}
            <div className="flex items-center justify-between px-4 pb-4 border-b border-black/5 shrink-0 bg-[#F2F2F7] relative z-20">
              <div className="flex items-center gap-3">
                <div className="w-10 h-10 bg-white rounded-xl flex items-center justify-center shadow-sm">
                   <svg className="w-6 h-6 text-[#5B65DC]" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5"><path d="M19 14c1.49-1.46 3-3.21 3-5.5A5.5 5.5 0 0 0 16.5 3c-1.76 0-3 .5-4.5 2-1.5-1.5-2.74-2-4.5-2A5.5 5.5 0 0 0 2 8.5c0 2.3 1.5 4.05 3 5.5l7 7Z"/><path d="M12 5 9.04 9.2a2 2 0 0 0-.28 1.41l.36 1.76a2 2 0 0 0 1.96 1.6h3.84a2 2 0 0 0 1.96-1.6l.36-1.76a2 2 0 0 0-.28-1.41L12 5Z"/></svg>
                </div>
                <div className="flex flex-col">
                  <span className="text-[14px] font-semibold text-black leading-tight tracking-tight">Hospital Status</span>
                  <span className="text-[12px] text-black/50 leading-tight">hospital-status.com</span>
                  <div className="flex items-center gap-1 mt-0.5">
                    <span className="text-[10px] text-blue-500 font-medium">Opciones</span>
                    <svg className="w-2.5 h-2.5 text-blue-500/50" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><polyline points="9 18 15 12 9 6"></polyline></svg>
                  </div>
                </div>
              </div>
              <div className="w-8 h-8 bg-black/5 rounded-full flex items-center justify-center">
                <svg className="w-4 h-4 text-black/60" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><line x1="18" y1="6" x2="6" y2="18"></line><line x1="6" y1="6" x2="18" y2="18"></line></svg>
              </div>
            </div>

            {/* Scrolling Content */}
            <div className="flex-1 w-full overflow-hidden relative">
              <div 
                className="w-full flex flex-col pb-10 will-change-transform" 
                style={{ animation: 'sheetInnerScroll 13s infinite cubic-bezier(0.32, 0.72, 0, 1)' }}
              >
                <div className="h-4 shrink-0"></div>

                <div className="flex gap-4 px-4 overflow-hidden mb-4 shrink-0">
                  <div className="flex flex-col items-center gap-1">
                    <div className="w-[60px] h-[60px] bg-white rounded-[1rem] flex items-center justify-center shadow-sm"><div className="w-10 h-10 bg-blue-50 rounded-full"></div></div>
                    <span className="text-[10px] text-black">Airdrop</span>
                  </div>
                  <div className="flex flex-col items-center gap-1">
                    <div className="w-[60px] h-[60px] bg-white rounded-[1rem] flex items-center justify-center shadow-sm"><div className="w-10 h-10 bg-emerald-50 rounded-full"></div></div>
                    <span className="text-[10px] text-black">Mensajes</span>
                  </div>
                  <div className="flex flex-col items-center gap-1">
                    <div className="w-[60px] h-[60px] bg-white rounded-[1rem] flex items-center justify-center shadow-sm"><div className="w-10 h-10 bg-purple-50 rounded-full"></div></div>
                    <span className="text-[10px] text-black">WhatsApp</span>
                  </div>
                  <div className="flex flex-col items-center gap-1">
                    <div className="w-[60px] h-[60px] bg-white rounded-[1rem] flex items-center justify-center shadow-sm"><div className="w-10 h-10 bg-blue-100 rounded-full"></div></div>
                    <span className="text-[10px] text-black">Mail</span>
                  </div>
                </div>
                
                <div className="w-full border-b border-black/5 mb-4 shrink-0 px-4"></div>

                <div className="flex gap-4 px-4 overflow-hidden mb-6 shrink-0">
                  <div className="flex flex-col items-center gap-1">
                    <div className="w-[50px] h-[50px] bg-white rounded-full flex items-center justify-center shadow-sm text-black/70">
                      <svg className="w-5 h-5" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5"><rect x="9" y="9" width="13" height="13" rx="2" ry="2"></rect></svg>
                    </div><span className="text-[10px] text-black">Copiar</span>
                  </div>
                  <div className="flex flex-col items-center gap-1">
                    <div className="w-[50px] h-[50px] bg-white rounded-full flex items-center justify-center shadow-sm text-black/70">
                      <svg className="w-5 h-5" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5"><path d="M19 21l-7-5-7 5V5a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2z"></path></svg>
                    </div><span className="text-[10px] text-black">Agregar</span>
                  </div>
                   <div className="flex flex-col items-center gap-1">
                    <div className="w-[50px] h-[50px] bg-white rounded-full flex items-center justify-center shadow-sm text-black/70">
                      <svg className="w-5 h-5" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5"><line x1="12" y1="5" x2="12" y2="19"></line><line x1="5" y1="12" x2="19" y2="12"></line></svg>
                    </div><span className="text-[10px] text-black">Lecturas</span>
                  </div>
                   <div className="flex flex-col items-center gap-1">
                    <div className="w-[50px] h-[50px] bg-white rounded-full flex items-center justify-center shadow-sm text-black/70">
                      <svg className="w-5 h-5" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5"><polyline points="18 15 12 9 6 15"></polyline></svg>
                    </div><span className="text-[10px] text-black">Menos</span>
                  </div>
                </div>

                <div className="mx-4 bg-white rounded-[14px] overflow-hidden shadow-sm flex flex-col mb-4 shrink-0">
                  <div className="flex items-center gap-3 px-4 py-3 border-b border-black/5">
                    <svg className="w-5 h-5 text-black/80" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5"><path d="M4 19.5A2.5 2.5 0 0 1 6.5 17H20"></path><path d="M6.5 2H20v20H6.5A2.5 2.5 0 0 1 4 19.5v-15A2.5 2.5 0 0 1 6.5 2z"></path></svg>
                    <span className="text-[15px] text-black">Agregar marcador a...</span>
                  </div>
                  <div className="flex items-center gap-3 px-4 py-3 border-b border-black/5">
                    <svg className="w-5 h-5 text-black/80" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5"><polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"></polygon></svg>
                    <span className="text-[15px] text-black">Agregar a Favoritos</span>
                  </div>
                  <div className="flex items-center gap-3 px-4 py-3 border-b border-black/5">
                    <svg className="w-5 h-5 text-black/80" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5"><path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"></path><path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z"></path></svg>
                    <span className="text-[15px] text-black">Agregar a nota rápida</span>
                  </div>
                  <div className="flex items-center gap-3 px-4 py-3 border-b border-black/5">
                    <svg className="w-5 h-5 text-black/80" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5"><path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"></path><polyline points="7 10 12 15 17 10"></polyline><line x1="12" y1="15" x2="12" y2="3"></line></svg>
                    <span className="text-[15px] text-black">Guardar en Archivos</span>
                  </div>
                  <div className="flex items-center gap-3 px-4 py-3 border-b border-black/5">
                     <svg className="w-5 h-5 text-black/80" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5"><circle cx="11" cy="11" r="8"></circle><line x1="21" y1="21" x2="16.65" y2="16.65"></line><line x1="11" y1="8" x2="11" y2="14"></line><line x1="8" y1="11" x2="14" y2="11"></line></svg>
                    <span className="text-[15px] text-black">Buscar en la página</span>
                  </div>

                  {/* Target Button */}
                  <div 
                    className="flex items-center gap-3 px-4 py-3 transition-transform bg-[#5B65DC]/5 rounded-xl mx-2 my-1 border border-[#5B65DC]/20"
                    style={{ animation: 'addBtnHighlight 13s infinite cubic-bezier(0.4, 0, 0.2, 1)' }}
                  >
                    <div className="w-[22px] h-[22px] bg-white border-[1.5px] border-[#5B65DC] rounded-[5px] flex items-center justify-center shrink-0 shadow-sm">
                       <svg className="w-4 h-4 text-[#5B65DC]" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><line x1="12" y1="5" x2="12" y2="19"></line><line x1="5" y1="12" x2="19" y2="12"></line></svg>
                    </div>
                    <span className="text-[15px] text-[#5B65DC] font-semibold">Agregar a Inicio</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* ====== 2. HOME SCREEN CONTEXT (Appears at T=51%) ====== */}
      <div 
        className="absolute inset-0 bg-gradient-to-b from-[#2E335A] to-[#1C1F3D] flex flex-col z-20 will-change-transform"
        style={{ animation: 'homeScreenEnter 13s infinite cubic-bezier(0.32, 0.72, 0, 1)' }}
      >
        {/* Apps Grid */}
        <div className="flex-1 w-full px-6 pt-16">
          <div className="grid grid-cols-4 gap-x-4 gap-y-6">
            {/* Row 1 dummy apps */}
            <div className="w-[48px] h-[48px] bg-green-500 rounded-[12px]"></div>
            <div className="w-[48px] h-[48px] bg-blue-400 rounded-[12px]"></div>
            <div className="w-[48px] h-[48px] bg-yellow-400 rounded-[12px]"></div>
            <div className="w-[48px] h-[48px] bg-gray-300 rounded-[12px]"></div>
            
            {/* Row 2 dummy apps */}
            <div className="w-[48px] h-[48px] bg-red-400 rounded-[12px]"></div>
            <div className="w-[48px] h-[48px] bg-purple-400 rounded-[12px]"></div>
            <div className="w-[48px] h-[48px] bg-orange-400 rounded-[12px]"></div>
            
            {/* THE NEW APP DROP TARGET */}
            <div className="relative w-[48px] h-[48px]">
               <div 
                 className="absolute inset-0 bg-white rounded-[12px] shadow-lg flex items-center justify-center will-change-transform"
                 style={{ animation: 'appIconDrop 13s infinite cubic-bezier(0.34, 1.56, 0.64, 1)' }}
               >
                 <svg className="w-6 h-6 text-[#5B65DC]" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5"><path d="M19 14c1.49-1.46 3-3.21 3-5.5A5.5 5.5 0 0 0 16.5 3c-1.76 0-3 .5-4.5 2-1.5-1.5-2.74-2-4.5-2A5.5 5.5 0 0 0 2 8.5c0 2.3 1.5 4.05 3 5.5l7 7Z"/></svg>
               </div>
               
               {/* App label below */}
               <div 
                 className="absolute -bottom-4 w-full text-center"
                 style={{ animation: 'appIconDrop 13s infinite cubic-bezier(0.34, 1.56, 0.64, 1)' }}
               >
                 <span className="text-[9px] font-medium text-white/90">Status</span>
               </div>
            </div>
          </div>
        </div>
        
        {/* Dock Floor */}
        <div className="w-full pb-4 px-4 shrink-0 relative">
          <div className="absolute inset-4 top-0 bg-white/20 backdrop-blur-xl rounded-[20px] bottom-4"></div>
          <div className="relative flex justify-between px-3 py-3 w-full">
            <div className="w-[48px] h-[48px] bg-green-400 rounded-[12px]"></div>
            <div className="w-[48px] h-[48px] bg-sky-400 rounded-[12px]"></div>
            <div className="w-[48px] h-[48px] bg-red-500 rounded-[12px]"></div>
            <div className="w-[48px] h-[48px] bg-white/50 rounded-[12px]"></div>
          </div>
        </div>
      </div>

      {/* --- THE ANIMATED TOUCH POINT --- */}
      <div 
        className="absolute top-0 left-0 z-40 pointer-events-none flex items-center justify-center w-[40px] h-[40px] -ml-[20px] -mt-[20px] will-change-transform drop-shadow-xl" 
        style={{ animation: 'touchPointCore 13s infinite cubic-bezier(0.4, 0, 0.2, 1)' }}
      >
        <div className="w-8 h-8 rounded-full bg-[#5B65DC]/30 backdrop-blur-sm border-2 border-white flex items-center justify-center shadow-[0_4px_12px_rgba(91,101,220,0.5)]">
           <div 
             className="absolute w-[40px] h-[40px] rounded-full bg-[#5B65DC]" 
             style={{ animation: 'touchRipple 13s infinite cubic-bezier(0.4, 0, 0.2, 1)' }}
           ></div>
           <div className="w-3 h-3 bg-[#5B65DC] rounded-full shadow-inner relative z-10"></div>
        </div>
      </div>

    </div>
  );
};

export default IosInstallAnimation;
